import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom';
import { markInAppNavigation } from 'lib/api';

/** React Router navigate — session is kept alive across in-app route changes. */
export function navigateInApp(navigate: NavigateFunction, to: To, options?: NavigateOptions): void {
  markInAppNavigation();
  navigate(to, options);
}

/** True when the browser history stack has a previous in-app entry (React Router idx). */
export function canNavigateBack(): boolean {
  if (typeof window === 'undefined') return false;
  const idx = (window.history.state as { idx?: number } | null)?.idx;
  return typeof idx === 'number' && idx > 0;
}

/** Pop history when possible; otherwise navigate to fallback (no replace — keeps forward stack). */
export function goBackInApp(navigate: NavigateFunction, fallback: To, options?: NavigateOptions): void {
  markInAppNavigation();
  if (canNavigateBack()) {
    navigate(-1);
    return;
  }
  navigate(fallback, options);
}
